import { render, staticRenderFns } from "./CascadeAccessModal.vue?vue&type=template&id=66665d3d"
import script from "./CascadeAccessModal.vue?vue&type=script&lang=js"
export * from "./CascadeAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports